<mat-form-field appearance="outline" [ngClass]="{
  'w-100': true,
  'm-t-5': true,
  'mat-form-field-compact': size === 'compact',
  'mat-form-field-xs': size === 'xs'}">
  <input matInput [matDatepicker]="dp" [formControl]="date" placeholder="{{'datePicker.mmyyDatePicker' | translate}}"/>
  <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"
    panelClass="example-month-picker">
  </mat-datepicker>
</mat-form-field>